import { render, staticRenderFns } from "./AppContentBlockText.vue?vue&type=template&id=6ee3c631&scoped=true&"
import script from "./AppContentBlockText.vue?vue&type=script&lang=js&"
export * from "./AppContentBlockText.vue?vue&type=script&lang=js&"
import style0 from "./AppContentBlockText.vue?vue&type=style&index=0&id=6ee3c631&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee3c631",
  null
  
)

export default component.exports